export const UPDATE_CHECK_DATA = "UPDATE_CHECK_DATA";
export const UPDATE_SCAN_FRONT_RESPONSE = "UPDATE_SCAN_FRONT_RESPONSE";
export const UPDATE_SCAN_BACK_RESPONSE = "UPDATE_SCAN_BACK_RESPONSE";
export const UPDATE_CHECK_ERROR = "UPDATE_CHECK_ERROR";
export const CLEAN_CHECK_STATE = "CLEAN_CHECK_STATE";
export const SET_CHECK_REQUEST_LOADING = "SET_CHECK_REQUEST_LOADING";
export const CLEAN_CHECK_SCAN_ERROR = "CLEAN_CHECK_SCAN_ERROR";
export const UPDATE_RESERVATION_RESPONSE = "CREATE_RESERVATION_RESPONSE";
export const UPDATE_FRONT_PHOTO = "UPDATE_FRONT_PHOTO";
export const UPDATE_BACK_PHOTO = "UPDATE_BACK_PHOTO";
export const SHOW_CONFIRM_AMOUNT_DIALOG = "SHOW_CONFIRM_AMOUNT_DIALOG";
export const SET_CHECK_SCAN_PAYMENT_CONFIRMED = "SET_CHECK_SCAN_PAYMENT_CONFIRMED";
export const SET_DUPLICATE_ORDER_ID = "SET_DUPLICATE_ORDER_ID";
export const PROCESS_FRONT_CHECK_SCAN_IMAGE = "PROCESS_FRONT_CHECK_SCAN_IMAGE";
export const PROCESS_BACK_CHECK_SCAN_IMAGE = "PROCESS_BACK_CHECK_SCAN_IMAGE";
